import { render, staticRenderFns } from "./favourites.vue?vue&type=template&id=200c4094&"
import script from "./favourites.vue?vue&type=script&lang=js&"
export * from "./favourites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports